import Container from "@mui/material/Container";
import { Button, Stack, TextField, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useState, useEffect } from "react";
import firebaseConfig from "../firebase";
import { updateDoc, doc, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getFirestore } from 'firebase/firestore';
function WoodUpdate(props) {
  const db = getFirestore(firebaseConfig)
  const navigate = useNavigate()
  const {id} : {id: string} = useParams();
  const {update} = useSelector(state=>({...state }))
  const [woodName, setWoodName] = useState(update.woodName);
  const [woodSName, setWoodSName] = useState(update.woodSName);
  const [woodTName, setWoodTName] = useState(update.woodTName);
  const [woodLocate, setWoodLocate] = useState(update.woodLocate);
  const [woodDesc, setWoodDesc] = useState(update.woodDesc);
  const [woodImage, setWoodImage] = useState(update.woodImage);

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setWoodImage(base64);
    console.log(base64)
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const update_wood = async () => {
    const woodRef = doc(db, "Wood", id);
    await updateDoc(woodRef, {
      woodName: woodName,
      woodSName: woodSName,
      woodTName: woodTName,
      woodLocate: woodLocate,
      woodDesc: woodDesc,
      woodImage: woodImage
    });
    alert("บันทึกเรียบร้อย")
    navigate('/wood');

  };

  return (
    <Container class={Paper}>
      <Stack spacing={1.5}>

      <Typography
          variant="h1"
          sx={{
            fontWeight: "bold",
            fontSize: "2.25vw",
            marginTop: "20px",
            fontFamily: "Prompt",
          }}
        >
          แก้ไข {update.woodName}
        </Typography>
        <input type="file" 
        onChange={(e) => {
          uploadImage(e);
        }}/>
        <TextField
        inputProps={{ style: { fontFamily: "Prompt" } }}
        InputLabelProps={{ style: { fontFamily: "Prompt" } }}
        variant="standard"
          label="ชื่อไม้*"
          onChange={(event) => {
            setWoodName(event.target.value);
          }}
          value={woodName}
        />
        <TextField
        inputProps={{ style: { fontFamily: "Prompt" } }}
        InputLabelProps={{ style: { fontFamily: "Prompt" } }}
        variant="standard"
          label="ชื่อวิทยาศาสตร์*"
          onChange={(event) => {
            setWoodSName(event.target.value);
          }}
          value={woodSName}
        />
        <TextField
        inputProps={{ style: { fontFamily: "Prompt" } }}
        InputLabelProps={{ style: { fontFamily: "Prompt" } }}
        variant="standard"
          label="ชื่อทางการค้า*"
          onChange={(event) => {
            setWoodTName(event.target.value);
          }}
          value={woodTName}
        />
        <TextField
        inputProps={{ style: { fontFamily: "Prompt" } }}
        InputLabelProps={{ style: { fontFamily: "Prompt" } }}
        variant="standard"
          label="สถานที่*"
          onChange={(event) => {
            setWoodLocate(event.target.value);
          }}
          value={woodLocate}
        />
        <TextField
        inputProps={{ style: { fontFamily: "Prompt" } }}
        InputLabelProps={{ style: { fontFamily: "Prompt" } }}
        variant="standard"
          label="รายละเอียด*"
          multiline
          rows={4}
          onChange={(event) => {
            setWoodDesc(event.target.value);
          }}
          value={woodDesc}
        />
        <Stack direction="row" justifyContent="flex-end" spacing={3}>
        <Button  sx={{ fontFamily:'Prompt'}} onClick={() => navigate('/wood')} variant="text" color="error">ยกเลิก</Button>
          <Button sx={{ fontFamily:'Prompt'}} onClick={update_wood} variant="outlined" color="success"> บันทึก </Button>
        </Stack>
      </Stack>
    </Container>
  );

}
export default WoodUpdate